import { ObjectSchema, object, string } from 'yup';
import { useMemo } from 'react';
import { SetupProviderFormState } from '@Forms/providers/SetupProviderFormContext';

export const useSetupProviderUseCaseSchema = (): ObjectSchema<Partial<SetupProviderFormState>> => {
  return useMemo(
    () =>
      object<SetupProviderFormState>().shape({
        name: string().required('name is required'),
        apiUrl: string().required('api url is required'),
        syncRoundEnd: string().required('sync round end url is required'),
        status: string().required('status is required'),
        retryScheduledSendCredit: string().required('retry scheduled send credit url is required'),
        refundOnCreditFail: string().required('refund on credit fail url is required'),
        filterExternalProviderBets: string().required(
          'filter external provider bets is required field'
        ),
        isInternal: string().required('is internal is required field'),
        integrationType: string().required('integration type is required'),
        syncRaindrop: string().required('sync raindrop is required'),
        syncFreebet: string().required('sync freebet is required'),
        notifyOnLastFreebet: string().required('notify on last freebet is required'),
        enableInactivityScreen: string().required('enable inactivity screen is required'),
        raindropType: string().required('raindrop type is required'),
      }),
    []
  );
};
